import Releaselogfeature from 'features/releaselog/release-log-feature';
import ReleaseLogFooter from 'features/releaselog/release-log-footer';
import Releaseloghero from 'features/releaselog/release-log-hero';
import ReleaseLogNavbar from 'features/releaselog/release-log-navbar';
import ReleaseLogPlans from 'features/releaselog/release-log-plans';
import ReleaseLogPricing from 'features/releaselog/release-log-pricing';
import { NextSeo } from 'next-seo';

export default function Releaselog() {
  const SEO = {
    title: 'ReleaseLog - The changelog tool for SaaS',
    description:
      'Easiest way to keep your customers in the loop about your product.',
    openGraph: {
      type: 'website',
      url: `${process.env.SITE_URL}/releaselog`,
      site_name: 'ReleaseLog',
      title: 'ReleaseLog - The changelog tool for SaaS',
      description:
        'Easiest way to keep your customers in the loop about your product.',
      images: [
        {
          url: `${process.env.NEXT_PUBLIC_SITE_URL}/assets/releaselog.png`,
        },
      ],
    },
    canonicalUrl: `${process.env.SITE_URL}/releaselog`,
  };

  const PLANS = [
    {
      type: 'STARTER',
      price: {
        month: '0$',
        year: '0$',
      },
      description: 'Free monthly plan with basic features for new businesses',
      visitorCount: '1000',
      benefitHeading: 'Key Features',
      benefits: [
        'Standalone Changelog',
        'Customize the changelog to fit your UI',
        'Fast & Easy CMS to draft & publish release notes',
        'In-App Widget',
      ],
    },
    {
      type: 'GROWTH',
      price: {
        month: '30$',
        year: '25$',
      },
      description: 'Affordable monthly plan for growing businesses',
      visitorCount: '10,000',
      benefitHeading: 'Everything in Starter, Plus:',
      benefits: ['Customer domain', 'Remove watermark'],
      active: false,
    },
    {
      type: 'SCALE',
      price: {
        month: '54$',
        year: '45$',
      },
      description: 'Premium features ideal for established businesses',
      visitorCount: 'Unlimited',
      benefitHeading: 'Everything in Growth Plus:',
      benefits: ['Priority support'],
      active: false,
    },
  ];

  return (
    <div className="bg-[#fcfcfc]">
      <NextSeo {...SEO} />
      <ReleaseLogNavbar />
      <div className="container mx-auto">
        <Releaseloghero />
        <Releaselogfeature />
        <ReleaseLogPlans plans={PLANS} />
      </div>
      <ReleaseLogFooter />
    </div>
  );
}
